import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=5caa4d22"
import script from "./icon.js?vue&type=script&lang=js&external"
export * from "./icon.js?vue&type=script&lang=js&external"
import style0 from "./icon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports